/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Pit3_DInputs */

const en_to_xml_pit3_d = /** @type {(inputs: To_Xml_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SOAP envelopes and most enterprise schemas require namespace declarations and prefixed element names. The output here has neither, so it is a starting point for a request body rather than a finished one. Add the envelope and the namespace attributes after converting.`)
};

const ko_to_xml_pit3_d = /** @type {(inputs: To_Xml_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SOAP 엔벨로프와 대부분의 엔터프라이즈 스키마는 네임스페이스 선언과 접두사가 붙은 요소 이름을 요구합니다. 여기 출력에는 둘 다 없으므로, 완성된 요청 본문이 아니라 출발점입니다. 변환 후에 엔벨로프와 네임스페이스 속성을 추가하세요.`)
};

const ja_to_xml_pit3_d = /** @type {(inputs: To_Xml_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SOAP エンベロープと大半の企業スキーマは、名前空間宣言と接頭辞付きの要素名を要求します。ここの出力にはどちらもないので、完成したリクエスト本文ではなく出発点です。変換後にエンベロープと名前空間属性を追加してください。`)
};

/**
* | output |
* | --- |
* | "SOAP envelopes and most enterprise schemas require namespace declarations and prefixed element names. The output here has neither, so it is a starting point ..." |
*
* @param {To_Xml_Pit3_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_pit3_d = /** @type {((inputs?: To_Xml_Pit3_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Pit3_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_pit3_d(inputs)
	if (locale === "ko") return ko_to_xml_pit3_d(inputs)
	return ja_to_xml_pit3_d(inputs)
});